
























































import { defineComponent, PropType } from '@vue/composition-api'
import { BRDisplayType } from '../composables/useAggregationResultTable'

interface Header {
  [key: string]: any;
  [key: number]: any;
}

export default defineComponent({
  name: 'BRDisplaySettingsDialogListItem',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    businessRuleHeaders: {
      type: Array as PropType<Header[]>,
      default: () => [],
    },
    brDisplaySettings: {
      type: Object as PropType<Record<string, BRDisplayType>>,
      default: () => ({}),
    },
  },
  setup() {
    const brDisplayTypeItems = [
      { text: '合計', value: 'sum' },
      { text: 'ユニーク', value: 'unique' },
      { text: '最大', value: 'max' },
      { text: '最終値', value: 'last' },
      { text: '平均', value: 'avg' },
      { text: '非表示', value: 'hidden' },
    ]

    return { brDisplayTypeItems }
  },
})
